import {range} from 'external/lodash'
import {React, useContext, useMemo} from 'external/react'
import { TeacherContext } from 'teacher/context'

import Course from './Course'
export default function MyCourses () {
  const context = useContext(TeacherContext)
  const {myCourses, sizes} = context
  const coursesPerRow = Math.floor((sizes.width  - 48) / 350)
  const fillersNeeded = coursesPerRow - myCourses.length % coursesPerRow
  const courses = useMemo(() => (myCourses || []).map((course, index) => <Course key={index} {...course} context={context} />), [myCourses])
  return (
    <div className="courses">
      {courses}
      {range(fillersNeeded).map(key => <div key={key} className="course filler" />)}
    </div>
  )
}
